// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Linkedin: React.FC = () => {
    return <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false"><path d="M22.286 24c.943 0 1.714-.777 1.714-1.73V1.73C24 .777 23.229 0 22.286 0H1.709C.766 0 0 .777 0 1.73v20.54C0 23.223.766 24 1.709 24h20.577zM5.475 7.554a2.063 2.063 0 010-4.125c1.136 0 2.063.926 2.063 2.062a2.06 2.06 0 01-2.063 2.063zm7.57 13.017H9.487V9.118H12.9v1.564h.048c.477-.9 1.64-1.848 3.37-1.848 3.6 0 4.27 2.373 4.27 5.459v6.278H17.03V15c0-1.329-.026-3.038-1.848-3.038-1.853 0-2.137 1.447-2.137 2.942v5.667zm-5.786 0H3.696V9.118H7.26V20.57z" fillRule="nonzero"/></svg>;
};

export default React.memo(Linkedin);
